namespace $.$$ {

	export class $shm_hitalama_map_widget_float extends $.$shm_hitalama_map_widget_float {

		head_view() {
			if( this.hide_head_tools() ) return []
			return this.head_showed() ? super.head_view() : []
		}

		sub(): readonly ( any )[] {
			return this.scrollable() ? this.sub_scrollable() : super.sub()
		}

		map(): $shm_hitalama_map {
			return this.Map_page().map()
		}

		@ $mol_mem
		selected( next?: boolean ): boolean {
			return this.Map_page().selected( this.widget().link(), next )
		}

		@ $mol_mem
		hovered( next?: boolean ): boolean {
			return this.Map_page().hovered( this.widget().link(), next )
		}

		stickable(): boolean {
			return this.Map_page().stickable()
		}

		sticks_x(): readonly number[] {
			return this.Map_page().sticks_x( this.widget().link() )
		}

		sticks_y(): readonly number[] {
			return this.Map_page().sticks_y( this.widget().link() )
		}

		drags_synced(): readonly ( $.$rise_drag )[] {
			return this.Map_page().drags_synced( this.widget().link() )
		}

		on_contextmenu( next?: PointerEvent | null ) {
			if( next == null ) return null
			return this.Map_page().widget_event_contextmenu( this.widget().link(), next )
		}

		head_showed(): boolean {
			return this.Map_page().widget_headers_visible()
		}

		toolbar_type(): string {
			return `(${this.widget().type()})`
		}
		
		@ $mol_action
		delete_from_map() {
			this.map().widget_cut( this.widget().link() )
		}

		@ $mol_mem
		y( next?: number ): number {
			if( this.locked() ) return this.$.$mol_mem_cached(()=>this.y()) ?? next!
			return super.y(next)
		}

		@ $mol_mem
		x( next?: number ): number {
			if( this.locked() ) return this.$.$mol_mem_cached(()=>this.x()) ?? next!
			return super.x(next)
		}

		@ $mol_mem
		x_stick( next?: number ) {
			return this.widget().body_x(next)
		}

		@ $mol_mem
		y_stick( next?: number ) {
			return this.widget().body_y(next)
		}

		@ $mol_mem
		bottom_edge_y_stick( next?: number ) {
			return this.widget().bottom_edge_y(next)
		}

		@ $mol_mem
		right_edge_x_stick( next?: number ) {
			return this.widget().right_edge_x(next)
		}

		@ $mol_mem
		top_edge_y_stick( next?: number ) {
			return this.widget().Top_edge_y(next)?.val(next) ?? 0
		}

		@ $mol_mem
		left_edge_x_stick( next?: number ) {
			return this.widget().Left_edge_x(next)?.val(next) ?? 0
		}

		hide_head_tools( next?: boolean ) {
			return this.widget().hide_head_tools( next )
		}

		@ $mol_mem
		title( next?: string ): string {
			return this.widget().title( next )
		}

		bind_view() {
			this.widget().view( this )
		}

		ref_str() {
			return this.widget().link().toString()!
		}

		z( next?: number ) {
			return this.widget().z( next )
		}

		delete() {
			this.delete_from_map()
		}

		@ $mol_mem
		opacity( next?: number ) {
			return this.widget().opacity( next )
		}

		@ $mol_mem
		locked( next?: boolean ) {
			return this.widget().locked(next)
		}

		opacity_str(): string {
			return this.opacity().toString()
		}

		outline(): readonly ( any )[] {
			if( this.Map_page().widget_tools_hidden() ) return []
			return super.outline()
		}

		edges(): readonly ( any )[] {
			if( this.Map_page().widget_tools_hidden() ) return []
			// let edges = this.hide_head_tools() ? [
			// 	this.Top_edge(),
			// 	this.Left_edge(),
			// 	this.Bottom_edge(),
			// 	this.Right_edge(),
			// ] : super.edges()
			let edges = super.edges()
			if( this.selected() && this.Map_page().selected_links().length > 1 ) return []
			return this.selected() && !this.dragged() ? edges : []
		}

		toolbar(): readonly ( any )[] {
			if( this.Map_page().widget_tools_hidden() ) return []
			if( this.hide_head_tools() ) return []
			if( this.Map_page().selected_links().length > 1 ) return []
			return this.selected() && !this.dragged() ? super.toolbar() : []
		}

		@ $mol_mem
		toolbar_transform() {
			return $shm_hitalama_map_float_toolbar_transform( this.zoom() )
		}

		is_inner() {
			return Boolean( this.widget().container_widget() )
		}

		some_container_dragged() {
			let container = this.widget().container_widget()
			while (container) {
				if( this.Map_page().Widget( container.link() ).Sub().transforming() ) return true
				container = container.container_widget()
			}
			return false
		}

		some_selected_container_in_selectbox_drag() {
			if( !this.Map_page().selectbox_dragged() ) return false

			let container = this.widget().container_widget()
			while (container) {
				const container_link = container.link()
				if( this.Map_page().selected_links().some( link => link.str == container_link.str ) ) return true
				container = container.container_widget()
			}
			return false
		}

		@ $mol_mem
		transition() {
			if( this.selected() && this.Map_page().selectbox_dragged() ) return 'none'
			if( this.some_selected_container_in_selectbox_drag() ) return 'none'
			if( this.some_container_dragged() ) return 'none'

			return ( this.transforming() ) ? 'none' : this.transition_smooth()
		}

		selected_attr() {
			return this.locked() ? false : this.selected()
		}

		dragged_attr() {
			return this.locked() ? false : this.dragged() || ( this.selected() && this.Map_page().selectbox_dragged() )
		}

		dragged(): ReturnType<ReturnType<$.$rise_resize[ "Drag_view" ]>[ "dragged" ]> {
			return this.Drag_view().dragged()
		}

		zoom_for_resizers() {
			return Math.min( 5, this.zoom() )
		}

		resizer_transform() {
			return $shm_hitalama_map_float_resizer_transform( this.zoom() )
		}

		resizer_line_x_transform() {
			return $shm_hitalama_map_float_resizer_line_x_transform( this.zoom() )
		}

		resizer_line_y_transform() {
			return $shm_hitalama_map_float_resizer_line_y_transform( this.zoom() )
		}

		@ $mol_mem
		has_scrollbar_y() {
			const el = this.Content_scroll().dom_node_actual()
			return el.scrollHeight > el.clientHeight
		}
		
		@ $mol_mem
		has_scrollbar_x() {
			const el = this.Content_scroll().dom_node_actual()
			return el.scrollWidth > el.clientWidth
		}

		hover_styled() {
			return this.Map_page().hover_styled( this.widget().link() )
		}

		pointerdown_last?: PointerEvent
		pointerdown( event: PointerEvent ) {
			this.pointerdown_last = event
		}

		content_pointerdown_last?: { time: number, x: number, y: number, button: number }
		content_pointerdown_doubled( event: PointerEvent ) {
			const time = performance.now()
			const last = this.content_pointerdown_last
			this.content_pointerdown_last = {
				time,
				x: event.clientX,
				y: event.clientY,
				button: event.button,
			}

			if( !last ) return false
			if( last.button !== event.button ) return false
			if( time - last.time > 500 ) return false

			const shift_x = event.clientX - last.x
			const shift_y = event.clientY - last.y
			return shift_x * shift_x + shift_y * shift_y < 25
		}

		content_double_click( event: PointerEvent ) {
		}

		skip_drag( el: Element ) {
			if( window.getComputedStyle(el).userSelect == 'text' ) return true
			
			return ['RISE_DRAG_VIEW','MOL_BUTTON_MINOR','MOL_BUTTON_MAJOR','MOL_DIMMER'].includes(el?.tagName)
				|| $shm_hitalama_is_input( el )
		}
		
		@ $mol_mem
		color( next?: string ) {
			return this.widget().color(next) ?? 'var(--mol_theme_text)'
		}

		@ $mol_mem
		font_size( next?: number ) {
			return this.widget().font_size(next)
		}

		@ $mol_mem
		font_size_px() {
			return this.font_size() + 'px'
		}

		@ $mol_mem
		font_family( next?: string ) {
			return this.widget().font_family(next)
		}

		@ $mol_mem
		auto_height( next?: boolean ) {
			return this.widget().auto_height(next)
		}

		fullsize_min_height() {
			return this.auto_height() ? '0' : '100%'
		}

		content_scroll_overflow() {
			return this.auto_height() ? 'hidden' : ''
		}

		@ $mol_mem
		drag_overlap_pointer_events() {
			return this.Map_page().Pane().drag_mode_enabled() ? 'auto' : 'none'
		}

		drag_overlap(): readonly ( any )[] {
			return this.Map_page().Pane().drag_mode_enabled() ? super.drag_overlap() : []
		}

		@ $mol_action
		auto_height_calc() {
			const content = this.Fullsize_wrapper().dom_node_actual()
			const head = this.head_view().length
				? this.Widget_head().dom_node_actual().getBoundingClientRect().height / this.zoom()
				: 0
			return Math.ceil( content.scrollHeight + head )
		}

		height_px(): string {
			if( !this.auto_height() ) return super.height_px()

			this.$.$mol_state_time.now( 100 )

			const height = this.auto_height_calc()
			return ( height > 0 ? height : this.height() ) + 'px'
		}

		@ $mol_mem
		auto_height_fit() {
			if( !this.auto_height() ) return null
			if( this.transforming() ) return null

			this.$.$mol_state_time.now( 100 ) //fix //todo

			const height = this.auto_height_calc()
			if( height > 0 && Math.abs( this.height() - height ) > 1 ) this.height( height )

			return null
		}

		color_with_opacity( color: string, opacity: number ): string {
			if( !color || color == 'transparent' ) return color

			opacity = Math.max( 0, Math.min( 1, opacity ) )
			const match = color.match( /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i )
			if( !match ) return color

			const [ , red, green, blue ] = match
			return `rgba(${ parseInt( red, 16 ) }, ${ parseInt( green, 16 ) }, ${ parseInt( blue, 16 ) }, ${ opacity })`
		}

		@ $mol_mem
		background_style(): string {
			return this.color_with_opacity(
				this.widget().background_color(),
				this.widget().background_opacity(),
			)
		}

		@ $mol_mem
		border_color_style(): string {
			if( this.widget().border_width() <= 0 ) return ''

			return this.color_with_opacity(
				this.widget().border_color(),
				this.widget().border_opacity(),
			)
		}

		@ $mol_mem
		border_width_px(): string {
			const width = Math.max( 0, this.widget().border_width() )
			if( width === 0 ) return ''

			return `${ width }px`
		}

		border_style(): string {
			if( this.widget().border_width() <= 0 ) return ''

			return this.widget().border_style()
		}

		on_drag_start( next?: any ) {
			super.on_drag_start( next )
			this.selected( true )
		}

		content_pointerdown( event: PointerEvent ) {
			if( this.Content_scroll().dom_node_actual().matches( ':popover-open' ) ) return

			const el = (event.target as any) as Element

			const container = this.widget().container_widget()
			if( container ) {
				if( this.content_pointerdown_doubled( event ) ) {
					this.Map_page().selected_links( [ this.widget().link() ] )
					this.content_double_click( event )
					return
				}
				if( this.selected() ) {
					this.drag_pointerdown( event )
					return
				}
				this.Map_page().Widget( container.link() ).Sub().content_pointerdown( event )
				return
			}

			if( this.selected() && this.Map_page().selected_links().length > 1 ) {
				this.Map_page().Selectbox().pointerdown( event )
				return
			}
			
			if( this.skip_drag( el ) ) {
				if( !this.Map_page().Pane().drag_mode_enabled() ) {
					this.selected(true)
					return
				}
			}

			this.drag_pointerdown( event )
		}

		event_contextmenu( event: PointerEvent ) {
			if( $shm_hitalama_is_input( event?.target as Element ) ) {
				return
			}

			event.preventDefault()

			if( !this.pointerdown_last
				|| $shm_hitalama_is_panning( this.pointerdown_last, event )
			) return
			
			this.on_contextmenu( event )
		}

		@ $mol_mem
		control_attr(): boolean {
			// return false
			const link = this.widget().controlled_widget()?.link()
				?? this.widget().settings_widget()?.link()
				?? this.widget().code_widget()?.link()
				?? this.widget().view_widget()?.link()
			return link ? this.Map_page().selected(link) : false
		}
		
	}

}
